import { createContext, useContext, useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem("li_token");
    if (!token) {
      setAdmin(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setAdmin(data);
    } catch (e) {
      setAdmin(null);
      localStorage.removeItem("li_token");
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    // If returning from Google OAuth callback, let AuthCallback handle it first.
    if (window.location.hash && window.location.hash.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("li_token", data.access_token);
    setAdmin(data.admin);
    return data;
  };

  const setSessionToken = async (token) => {
    localStorage.setItem("li_token", token);
    await checkAuth();
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      // Non-fatal — the server-side session will expire on its own.
      // We still want visibility in dev tools / Sentry.
      if (typeof window !== "undefined" && window.console) {
        console.warn("Logout request failed; clearing client session anyway.", err);
      }
    }
    localStorage.removeItem("li_token");
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, loading, login, logout, checkAuth, setSessionToken }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
